import Projects from '../components/Projects'

function Home({ t, lang }) {
      return (
        <main className="page-container bg-custom">
            <div className='container text-center'>
              <h1 className='page-title'>{t("nav_projects").toUpperCase()}</h1>
            
              <Projects />
            </div>
        </main>
      );
    }
    
    export default Home;